const decodeHTMLEntities = (str) => {
    /* /!\ doesn't decode all entities, careful /!\ */
    if (typeof str === "undefined" || str === null || !str?.length) {
        console.warn("decoding empty string"); //eslint-disable-line
        return "";
    }
    const namedEntities = {
        "&bull;": "•",
        "&#x2d;": "-",
        "&ndash;": "–",
        "&mdash;": "—",
        "&middot;": "·",
        "&period;": ".",
        "&lsaquo;": "‹",
        "&rsaquo;": "›",
        "&frasl;": "⁄",
        "&laquo;": "«",
        "&raquo;": "»",
        "&le;": "≤",
        "&lt;": "<",
        "&ge;": "≥",
        "&gt;": ">",
        "&nbsp;": String.fromCharCode(160),
        "&amp;": "&",
    };
    Object.entries(namedEntities).forEach((e) => {
        str = str.replace(new RegExp(e[0], "g"), e[1]);
    });
    return str.replace(/&#([0-9]{1,4});/gi, (match, numStr) => {
        var num = parseInt(numStr, 10);
        return String.fromCharCode(num);
    });
};
export default decodeHTMLEntities;
